import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicDialogComponent } from 'primeng/dynamicdialog';

@Component({
  selector: 'split-agenda-bloqueio',
  templateUrl: './agenda-bloqueio.component.html',
  styleUrls: ['./agenda-bloqueio.component.scss']
})
export class AgendaBloqueioComponent {
  form: FormGroup = new FormGroup({});
  hora1 = '10:40';
  hora2 = '12:20';
  constructor(public config: DynamicDialogComponent) {}
  
  salvar() {
    this.config.close();
  }
  cancelar() {
    this.config.close();
  }
}
